require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 307
// module chunks = 16